export default "__VITE_ASSET__eV9CmGoF__"